
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form } from 'antd';
import { useAppContext } from "../../../context/appContext";
import { CloseOutlined } from '@ant-design/icons';
const { TextArea } = Input;
const DeleteProfileModal = ({ displayDeleteProfile, setDisplayDeleteProfile, selectedProfile, handleProfileDelete }) => {
    const {
        state: { profiles, bots },
    } = useAppContext();

    const goBack = () => {
        setDisplayDeleteProfile(false);
    }
    const onClickDelete = () => {
        handleProfileDelete(selectedProfile.id)
        setDisplayDeleteProfile(false);
    }

    const findUsage = (id) => {
        let usageCount = 0
        bots.forEach(bot => {
            if (bot.host.id === id) {
                if (bot.active) {
                    usageCount++;
                }
            }
        })

        return usageCount;
    }

    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayDeleteProfile} footer={null} onCancel={() => { setDisplayDeleteProfile(false); }}>

            <div style={{ fontWeight: "600", color: "white" }}>Delete</div>
            <div style={{ color: "grey", marginTop: 10 }}>Are you sure you want to delete 'Bot Binance buy side'?</div>
            <div style={{ color: "grey", marginTop: 10 }}>Please check if there are bots using this below first.</div>
            <div style={{ color: "white", margin: "30px 0" }}>
                <div style={{ border: "1px solid grey", height: 50, width: "100%", }}>
                    <h1 style={{ width: 63, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: 5, backgroundColor: "black", color: "white" }}>USAGE</h1>
                    <span style={{ marginLeft: 15 }}>{findUsage(selectedProfile.id)}</span>
                </div>
            </div>


            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button onClick={() => { onClickDelete() }} style={{ backgroundColor: "#310002", border: "1px solid red", color: "white", flex: 1, height: 50 }} type="default">DELETE</Button>
            </div>
        </Modal>
    );
};

export default DeleteProfileModal;